import React, { useState } from 'react';
import { RadioButton } from '../../../components';
import { Spreadsheet } from './Spreadsheet';
import { PortfolioAnalytics } from './PortfolioAnalytics/PortfolioAnalytics';


import {
  Container,
  Controls,
  ControlsLabel,
  InputWrapper,
} from './UploadFilesStyles';

type Props = {};

enum UploadTypes {
  Spreadsheet = 'Spreadsheet',
  Benchmarks = 'Benchmarks from Portfolio Analytics'
};

export const UploadFiles: React.FC<Props> = () => {
  const [uploadType, setUploadType] = useState(UploadTypes.Spreadsheet);

  const showSpreadsheet = uploadType === UploadTypes.Spreadsheet;
  const showBenchmarks = uploadType === UploadTypes.Benchmarks;

  return (
    <Container>
      <Controls>
        <ControlsLabel>Upload Type</ControlsLabel>
        <InputWrapper>
          <RadioButton
            checked={showSpreadsheet}
            onClick={() => setUploadType(UploadTypes.Spreadsheet)}
          >
            {UploadTypes.Spreadsheet}
          </RadioButton>
        </InputWrapper>
        <InputWrapper>
          <RadioButton
            checked={showBenchmarks}
            onClick={() => setUploadType(UploadTypes.Benchmarks)}
          >
            {UploadTypes.Benchmarks}
          </RadioButton>
        </InputWrapper>
      </Controls>
      {showSpreadsheet && (
        <Spreadsheet />
      )}
      {showBenchmarks && (
        <PortfolioAnalytics />
      )}
    </Container>
  );
};